import React from 'react';
import { connect } from 'react-redux';
import I18N from '@leverege/i18n';
import Groupings from "./Groupings.js";
import AggRequestorFactory from "./AggRequestorFactory.js";
import FilterSourcesModel from "../filters/FilterSourcesModel.js";
const {
  tf
} = I18N.ns('molten.groupings.AggLoader');
class AggLoader extends React.Component {
  componentDidMount() {
    // Kick off agg load
    const {
      currentGrouping,
      groupingObjRef
    } = this.props;
    this.loadAgg();
    this.installUpdaters(groupingObjRef, currentGrouping);
  }

  /**
   * Check to see if we have a grouping, filter or group and install 
   * new updaters or start timers as apppropriate.
   */
  componentDidUpdate(prevProps, prevState) {
    const {
      filters,
      currentGrouping,
      groupingObjRef: objRef,
      searchFilter
    } = this.props;
    const {
      filters: pf,
      currentGrouping: pg,
      groupingObjRef: por,
      searchFilter: psf
    } = prevProps;
    if (objRef?.id !== por?.id || objRef?.ref !== por?.ref) {
      this.installUpdaters(objRef, currentGrouping);
    }
    if (filters !== pf || currentGrouping !== pg) {
      this.changeSelection = searchFilter?.metadata?.value !== psf?.metadata?.value;
      this.restartTimer(100); // this will combine rapid requests
    }
  }

  /**
   * Stop all the updaters and timers
   */
  componentWillUnmount() {
    this.unmounted = true;
    clearTimeout(this.timer);
    if (this.removeUpdateListener) {
      this.removeUpdateListener();
    }
  }

  /**
   * Install the updaters that can trigger updates to the aggs.
   */
  installUpdaters(objRef, grouping) {
    if (this.removeUpdateListener) {
      this.removeUpdateListener();
      this.removeUpdateListener = null;
    }
    if (grouping && objRef) {
      if (grouping && objRef && grouping.aggRequestorType) {
        const requestor = AggRequestorFactory.get(grouping.aggRequestorType);
        if (requestor && requestor.installUpdater) {
          this.removeUpdateListener = requestor.installUpdater(objRef, grouping, this.props, () => {
            this.restartTimer(1500);
          });
        }
      }
    }
  }

  /**
   * Triggers a load on the aggs. This will restart the timer on completion or error.
   */
  loadAgg = () => {
    if (this.unmounted) {
      return;
    }
    clearTimeout(this.timer);
    this.timer = null;
    const {
      filters,
      delegate,
      relationship,
      groupingObjRef,
      dispatch,
      currentGrouping
    } = this.props;
    if (currentGrouping != null && relationship != null) {
      const opts = {
        filters,
        delegate,
        changeSelection: this.changeSelection
      };
      dispatch(Groupings.requestGroupingAgg(groupingObjRef, relationship.path, opts)).then(() => {
        this.restartTimer();
      }, err => {
        this.restartTimer();
      });
    }
    this.changeSelection = false;
  };

  /**
   * Restarts the delaying timer.
   */
  restartTimer = (time = 30000) => {
    clearTimeout(this.timer);
    if (this.unmounted !== true) {
      this.timer = setTimeout(this.loadAgg, time);
    }
  };
  render() {
    return null;
  }
}
const ConnectedAggLoader = connect((state, props) => {
  return {
    currentGrouping: Groupings.getGrouping(state),
    groupingObjRef: Groupings.getObjRef(state),
    searchFilter: props.filters && FilterSourcesModel.getSource(props.filters, 'freeTextSearch')
  };
})(AggLoader);
ConnectedAggLoader.createPlugin = () => {
  return {
    id: 'molten.grouping.AggLoader',
    name: tf('name'),
    type: 'molten.GroupingAggLoader',
    location: 'hidden',
    matches: {
      type: ['GroupDataViewer', 'ItemInfoDataViewer']
    },
    component: ConnectedAggLoader
  };
};
export default ConnectedAggLoader;